import NameValueTable from '../../ui-components/NameValueTable'
import { roundOffAndFormatNumberWithCurrency } from '../../../utils/utils'

type WithdrawalAmountAndExitLoadProps = {
  withdrawalAmount: number
  exitLoad: number
}

export default function WithdrawalAmountAndExitLoad({ withdrawalAmount, exitLoad }: WithdrawalAmountAndExitLoadProps) {
  return (
    <div className='px-5'>
      <NameValueTable
        data={[
          {
            name: 'Withdrawal Amount',
            value: roundOffAndFormatNumberWithCurrency(withdrawalAmount).toString()
          },
          {
            name: 'Exit Load',
            value: roundOffAndFormatNumberWithCurrency(exitLoad).toString()
          }
        ]}
        gap={8}
      />
    </div>
  )
}
